import axios from "axios";
import moment from "moment";
import qs from "qs";
import CryptoJS from "crypto-js";
import urlencode from "urlencode";

import OSS from "ali-oss";
//第一个参数是你上传的文件类型，第二个是文件信息，第三个是文件名
export const uploadFile = async (fileType, file, fileName) => {
  const params = {
    AccessKeyId: "LTAI5tDmXAHfWfijAwzYAga7",
    // AccessKeyId: 'LTAI5t6HgSJJ7CiYc12vwP1E',
    Action: "AssumeRole",
    Format: "JSON",
    RoleArn: "acs:ram::1024137040541588:role/teachoss",
    RoleSessionName: "teachoss",
    SignatureMethod: "HMAC-SHA1",
    SignatureNonce: new Date().getTime().toLocaleString(),
    SignatureVersion: "1.0",
    Timestamp: new Date().toISOString().replace(/\..+/, "") + "Z",
    Version: "2015-04-01"
  };
  const CanonicalizedQueryString = qs.stringify(params);

  const StringToSign =
    "GET" + "&" + urlencode("/") + "&" + urlencode(CanonicalizedQueryString);

  // const key = 'SArz4cqYC8INbCO0nnlILwJXdKCDyI';
  const key = "k9HRlP8M3rcU09wSlJOYIPwwBFQurM";

  const sign = CryptoJS.enc.Base64.stringify(
    CryptoJS.HmacSHA1(StringToSign, `${key}&`)
  );
  const res = await axios.get("https://sts.aliyuncs.com", {
    params: {
      ...params,
      Signature: sign
    }
  });
  // cl s
  const accessKeyId = res.data.Credentials.AccessKeyId;
  const accessKeySecret = res.data.Credentials.AccessKeySecret;
  const securityToken = res.data.Credentials.SecurityToken;
  let client = new OSS({
    accessKeyId: accessKeyId,
    accessKeySecret: accessKeySecret,
    stsToken: securityToken,
    bucket: "airoteachnew",
    region: "oss-cn-beijing",
    secure: true
  });
  try {
    let env = "test";
    if (process.env.VUE_APP_ENV === "production") {
      env = "pro";
    }
    let result = "";
    result = await client.put(
      `${fileType}/${new Date().getTime()}.${fileName.split(".").slice(-1)[0]}`,
      file
    );
    return result;
  } catch (e) {
    console.log(e);
  }
};



// WEBPACK FOOTER //
// ./src/utils/alioss.js